import styled from 'styled-components';

import { GetStartedTabs } from '../../types';

type ContentNavigationProps = {
  className?: string;
  onSelect: (tab: GetStartedTabs) => void;
  activeTab: GetStartedTabs;
};

const ContentNavigation = ({ className = '', onSelect, activeTab }: ContentNavigationProps) => (
  <div className={className}>
    <ul>
      <li>
        <button
          onClick={() => onSelect('explore')}
          type="button"
          className={activeTab === 'explore' ? 'active' : ''}
        >
          Explore
        </button>
      </li>
      <li>
        <button
          onClick={() => onSelect('how-to-use')}
          className={activeTab === 'how-to-use' ? 'active' : ''}
          type="button"
        >
          How to Use
        </button>
      </li>
      <li>
        <button
          onClick={() => onSelect('design-principles')}
          className={activeTab === 'design-principles' ? 'active' : ''}
          type="button"
        >
          Design Principles
        </button>
      </li>
      <li>
        <button
          onClick={() => onSelect('about')}
          className={activeTab === 'about' ? 'active' : ''}
          type="button"
        >
          About
        </button>
      </li>
    </ul>
  </div>
);

const ContentNavigationStyled = styled(ContentNavigation)`
  border-bottom: 0.0625rem solid ${({ theme }) => theme.neutralBorder};
  margin-bottom: 2.5rem;

  ul {
    display: flex;
    list-style: none;
    gap: 1.5rem;
    margin: 0;
    padding-left: 0;
  }

  button {
    padding: 1.5rem 0;
    font-size: 0.875rem;
    line-height: 1.1428571429;
    color: ${({ theme }) => theme.neutralTextWeak};
    background: transparent;
    border: 0 none;
    position: relative;
    cursor: pointer;
    transition: all 0.3s ease-in-out;
    //letter-spacing: 0.1px;

    &::after {
      content: '';
      position: absolute;
      bottom: -0.0625rem;
      height: 0.125rem;
      background-color: transparent;
      width: 100%;
      left: 0;
      transition: background 0.3s ease-in-out;
    }

    &:hover {
      color: ${({ theme }) => theme.neutralText};

      &::after {
        background: ${({ theme }) => theme.neutralBorderMedium};
      }
    }

    &.active {
      color: ${({ theme }) => theme.neutralText};
      text-shadow:
        0 0 0.5px ${({ theme }) => theme.neutralText},
        0 0 0.5px ${({ theme }) => theme.neutralText};

      &::after {
        background: ${({ theme }) => theme.primaryAction};
      }
    }

    &:disabled {
      pointer-events: none;
      color: ${({ theme }) => theme.neutralTextDisabled};
    }
  }
`;

export default ContentNavigationStyled;
